import { NoBlending, ShaderMaterial, Uniform, Vector4 } from "three";

import fragmentShader from "./glsl/SubtractiveColour.frag";
import vertexShader from "./glsl/Common.vert";
import * as THREE from "three";

/**
 * A simple copy shader material.
 */

export class SubtractiveColourMaterial extends ShaderMaterial {

    constructor() {
        super({
            name: "SubtractiveColourMaterial",
            uniforms: {
                inputBuffer: new Uniform(null),
                opacity: new Uniform(1.0),
                blendID: new Uniform(0),
                CMYK: new Uniform(new Vector4(0, 0, 0, 0)),

                sat10: new Uniform(0),
                sat20: new Uniform(0),
                sat30: new Uniform(0),
                sat40: new Uniform(0),
                sat50: new Uniform(0),
            },
            blending: NoBlending,
            depthWrite: false,
            depthTest: false,
            fragmentShader,
            vertexShader
        });
    }


    /**
     * The input buffer.
     *
     * @type {Texture}
     */

    set inputBuffer(value) {

        this.uniforms.inputBuffer.value = value;

    }

    /**
     * Sets the input buffer.
     *
     * @deprecated Use inputBuffer instead.
     * @param {Number} value - The buffer.
     */

    setInputBuffer(value) {

        this.uniforms.inputBuffer.value = value;

    }

    /**
     * Returns the opacity.
     *
     * @deprecated Use opacity instead.
     * @return {Number} The opacity.
     */

    getOpacity(value) {

        return this.uniforms.opacity.value;

    }

    /**
     * Sets the opacity.
     *
     * @deprecated Use opacity instead.
     * @param {Number} value - The opacity.
     */

    setOpacity(value) {

        this.uniforms.opacity.value = value;

    }

}
